import { jsx as r } from "react/jsx-runtime";
import { createContext as e, useContext as i } from "react";
const o = { views: ["year", "month", "day"] }, t = e(o), a = ({ children: e2, value: i2 }) => r(t.Provider, { value: i2.views ? i2 : o, children: e2 }), m = () => i(t);
export {
  t as KendoDatePickerContext,
  a as KendoDatePickerProvider,
  m as useKendoDatePicker
};
//# sourceMappingURL=KendoDatePickerProvider.js.map
